<template>
  <q-dialog
    ref="dialog"
    v-model="shown"
    :persistent="persistent"
    transition-show="fade-in"
    transition-hide="fade-out"
  >
    <q-card
      :style="{ width: '560px' }"
      class="q-dialog-plugin q-mx-md"
    >
      <q-card-section class="row items-center q-mx-xs">
        <div
          v-if="finalTitle"
          class="text-h5"
        >
          {{ finalTitle }}
        </div>
        <q-space />
        <q-btn
          v-if="!persistent"
          icon="close"
          dense
          flat
          round
          @click="shown = false;"
        />
      </q-card-section>
      <q-card-section
        v-if="finalMessage"
        class="row q-mx-xs q-my-lg"
      >
        <div class="text-body">
          {{ finalMessage }}
        </div>
      </q-card-section>
      <q-card-section class="column full-width q-gutter-md">
        <q-btn
          v-for="option in finalOptions"
          :key="option.label"
          size="xl"
          class="col-auto"
          :color="option.color"
          @click="option.callback(option.value); shown = false;"
        >
          {{ option.label }}
        </q-btn>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'OptionsDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      required: false,
      type: String,
      default: null
    },
    message: {
      required: false,
      type: String,
      default: null
    },
    options: {
      required: false,
      type: Array,
      default: () => []
    },
    persistent: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value', 'hide'],
  data () {
    return {
      shown: false,
      finalTitle: null,
      finalMessage: null,
      finalOptions: []
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
      if (!this.shown) {
        this.$emit('hide')
      }
    },
    title () {
      this.finalTitle = this.title
    },
    message () {
      this.finalMessage = this.message
    },
    options () {
      this.finalOptions = this.options
    }
  },
  methods: {
    show (options = this.options, title = this.title, message = this.message) {
      this.finalTitle = title
      this.finalMessage = message
      this.finalOptions = options
      this.shown = true
    },
    hide () {
      this.shown = false
    }
  }
}
</script>
